import { render, staticRenderFns } from "./NewCampaignStep4.vue?vue&type=template&id=2206e717&scoped=true&"
import script from "./NewCampaignStep4.vue?vue&type=script&lang=js&"
export * from "./NewCampaignStep4.vue?vue&type=script&lang=js&"
import style0 from "./NewCampaignStep4.vue?vue&type=style&index=0&id=2206e717&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2206e717",
  null
  
)

export default component.exports